export default __webpack_public_path__ + "static/masjid_bg_wide-599d31a84d650d4a2c347c208776ace6.webp";